import React from 'react'
import { AuthRoles } from '../../Component/Auth/AuthRoles.js';

const TicketsRoute = [
    {
        path: '/tickets',
        component: React.lazy(() => import('./Tickets.js')),
        auth: AuthRoles.editor,
    }
]

export default TicketsRoute;